function n() {
  if (!(typeof window > "u"))
    return window;
}
export {
  n as u
};
//# sourceMappingURL=window-CRKligjd.mjs.map
